import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../../../GeneralUI/Styles';
import { Paper, InputLabel, Grid } from '@material-ui/core';
import Buttoncontrol from "../../../GeneralUI/Buttoncontrol";
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { TextField, Button } from '@material-ui/core';
import { SnackbarProvider, withSnackbar } from 'notistack';
import AutoComplete from '../../../GeneralUI/AutoComplete';

import { combineStyles } from '../../../../Libs/';

const styles = theme => ({
  button: {
    margin: theme.spacing(),
  },
  input: {
    display: 'none',
  }
});

class InformeManifiestoAseguradora extends Component {

  state = {
    data: [],
    fields: {
      FECHA_INICIAL_CREACION: null,
      FECHA_FINAL_CREACION: null,
      TERCERO_CODIGO_PROPIETARIO: null,
      TERCERO_CODIGO_CONDUCTOR: null,
      SUCURSAL_CODIGO: null,
      VEHICULO_CODIGO: null
    },
    paramsInforme: '/imprimir_informe/manifiesto/informe_manifiesto_aseguradora?FECHA_INICIAL_CREACION=' + null + '&FECHA_FINAL_CREACION=' + null + '&VEHICULO_CODIGO=' + null + '&SUCURSAL_CODIGO=' + null + '&TERCERO_CODIGO_PROPIETARIO=' + null + '&TERCERO_CODIGO_CONDUCTOR=' + null,
    responseForm: { Message: '', typeMessage: '' },
  };

  componentDidMount() {
    const params = this.props.match.params;

    if (!params.id) {
      return;
    }
  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = (event) => {
    let { fields } = this.state;
    let params = '';
    fields[event.target.id] = event.target.value;
    this.setState({ fields });

    params = '/imprimir_informe/manifiesto/informe_manifiesto_aseguradora?FECHA_INICIAL_CREACION=' + this.state.fields.FECHA_INICIAL_CREACION + '&FECHA_FINAL_CREACION=' + this.state.fields.FECHA_FINAL_CREACION + '&VEHICULO_CODIGO=' + this.state.fields.VEHICULO_CODIGO + '&TERCERO_CODIGO_CONDUCTOR=' + this.state.fields.TERCERO_CODIGO_CONDUCTOR + '&TERCERO_CODIGO_PROPIETARIO=' + this.state.fields.TERCERO_CODIGO_PROPIETARIO + '&SUCURSAL_CODIGO=' + this.state.fields.SUCURSAL_CODIGO;
    this.setState({ paramsInforme: params });
  }

  save = (response) => {
    let newState = {
      openSnackbar: true,
      responseForm: response.responseForm
    };

    if (newState.responseForm['typeMessage'] === 'success') {
      newState.data = response.data;
    }

    this.setState(newState);
    this.props.enqueueSnackbar(this.state.responseForm['Message'], { variant: this.state.responseForm['typeMessage'] });
  }

  render() {
    const { classes } = this.props;

    return (

      <Paper elevation={5} className={classes.mainPaper}>
        <form className={this.props.form} onSubmit={e => e.preventDefault()}>

          <Grid container spacing={3} className={classes.gridForm}>

            <InputLabel className={classes.tittleLabelForm}>
              Informe Aseguradora
            </InputLabel>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={classes.gridForm}>
              <TextField
                id="FECHA_INICIAL_CREACION"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                type="date"
                label="FechaCreacion Inicial"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={3} className={classes.gridForm}>
              <TextField
                id="FECHA_FINAL_CREACION"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                type="date"
                label="FechaCreacion Final (*)"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={classes.gridForm}>
              <AutoComplete
                id="SUCURSAL_CODIGO"
                tableName='Sucursal'
                fields={['sucursalCodigo', 'sucursalNombre']}
                primaryField='sucursalCodigo'
                aliases={['ID', 'Nombre']}
                searchField='sucursalNombre'
                placeHolder='Sucursal'
                onSelect={this.handleChange}
                value={this.state.fields["sucursalCodigo"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <AutoComplete
                id="VEHICULO_CODIGO"
                tableName='vw_vehiculo_activo'
                fields={['vehiculo_codigo', 'vehiculo_placa', 'conductor', 'configuracion']}
                isView={true}
                aliases={[{ value: 'ID', size: 1 }, { value: 'Placa', size: 3 }, { value: 'Conductor', size: 6 }, { value: 'Configuracion', size: 2 }]}
                size='xx'
                primaryField='vehiculo_codigo'
                searchField='vehiculo_placa'
                placeHolder='Seleccionar Vehiculo'
                onSelect={this.handleChange}
              />
            </Grid>
          </Grid>


          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <AutoComplete
                id="TERCERO_CODIGO_PROPIETARIO"
                tableName='Tercero'
                fields={['terceroCodigo', 'terceroDocumento', 'terceroRazonSocial']}
                primaryField='terceroCodigo'
                aliases={[{ value: 'ID', size: 1 }, { value: 'Documento', size: 2 }, { value: 'terceroRazonSocial', size: 9 }]}
                searchField='terceroRazonSocial'
                placeHolder='Seleccionar Tercero Propietario'
                onSelect={this.handleChange}
                size='xx'
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <AutoComplete
                id="TERCERO_CODIGO_CONDUCTOR"
                tableName='Tercero'
                fields={['terceroCodigo', 'terceroDocumento', 'terceroRazonSocial']}
                primaryField='terceroCodigo'
                aliases={[{ value: 'ID', size: 1 }, { value: 'Documento', size: 2 }, { value: 'terceroRazonSocial', size: 9 }]}
                searchField='terceroRazonSocial'
                placeHolder='Seleccionar Tercero Conductor'
                onSelect={this.handleChange}
                size='xx'
              />
            </Grid>
          </Grid>

        </form>


        <div id='buttonContainer'>
          <Buttoncontrol
            saveData={this.state.fields}
            moduleName='informe_manifiesto_aseguradora'
            paramsInforme={this.state.paramsInforme}
            save={this.save}
            primaryFields={['manifiestoCodigo']}
            url='/imprimir_informe/manifiesto/informe_manifiesto_aseguradora'
            isFormLite={true}
          />
        </div>

      </Paper>
    );
  }

}



InformeManifiestoAseguradora.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(combineStyles(styles, Styles))(InformeManifiestoAseguradora)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider key={6} maxSnack={1}
      action={[
        <Button key={6} variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}
    >
      <MyApp />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;